<div class="card ">
    <h5 class="card-header">Depositar</h5>
    <div class="card-body">
        <div class="form-group mt-2">
            <div class="row">
                <div class="col-auto">
                    <!-- <label for="inValor">Valor</label> -->
                    <label class="span-description">Digite o valor que você pretende depositar na sua cedente</label>
                    <input type="text" [textMask]="{mask: MASKS.currency.textMask}" class="form-control w-100" id="inValor" #inValor>
                </div>
                <div class="col-auto">
                    <label class="span-description">Data de vencimento</label>
                    <div class="input-group">
                        <input class="form-control" id="dtVencimento" #dtVencimento placeholder="dia/mês/ano" [dayTemplate]="customDay" [markDisabled]=" isDisabled" [value]="dataAtual" ngbDatepicker #d="ngbDatepicker" [readonly]="true">
                        <div class="input-group-append">
                            <button class="btn btn-outline-secondary calendar" (click)="d.toggle()" type="button"></button>
                        </div>
                    </div>

                    <ng-template class="custom-hover" #customDay let-date let-currentMonth="currentMonth" let-selected="selected" let-disabled="disabled" let-focused="focused">
                        <span class="custom-btn" [class.focused]="focused" [class.text-muted]="disabled">
                            {{ date.day }}
                        </span>
                    </ng-template>
                </div>

                <div class="col-3">
                    <label class="span-description">Selecione o destino</label>
                    <div class="input-group">
                        <select id="allocatedBalanceId" #allocatedBalanceId class="form-control w-100">
                            <option [value]="null">
                                Conta Digital
                            </option>
                            <option *ngFor="let item of allocatedBalances" [value]="item.allocatedBalanceId">
                                {{item.name}}
                            </option>
                        </select>
                    </div>

                </div>
            </div>
        </div>
        <!-- <div class="form-group">
            <label for="inBanco">Dado Bancário</label>
        </div> -->

        <ng-container *ngIf="temInscricaoMunicipal">
            <button [disabled]="!inValor" type="button" class="action-button" (click)="
                depositarViaPix(modalPIX, inValor.value, dtVencimento.value, allocatedBalanceId.value)">
                Gerar QR Code PIX
            </button>
            <button [disabled]="!inValor" type="button" class="action-button ml-3" (click)="
                depositarViaBoleto(inValor.value, dtVencimento.value, allocatedBalanceId.value)">
                Gerar Boleto
            </button>
        </ng-container>
        <!-- <span *ngIf="!temInscricaoMunicipal">Para gerar uma intenção de depósito, primero informe sua Inscrição Municipal em Administrativo > Dados da empresa</span> -->
    </div>
</div>

<ng-template #modalPIX let-modal>
    <div class="col-12 modal-header clean-modal-header">
        <div class="col-md-12">
            <div class="col-12 modal-header clean-modal-header">
                <div class="col-md-12 row" style="place-content: center;">
                    <h5 class="modal-title clean-modal-title">
                        Utilize o QR Code PIX abaixo para realizar o pagamento
                    </h5>
                    <div class="col-6 text-center">
                        <img src="{{'data:image/gif;base64,' + qrCodePix.brCodeImage}}" class="qrcode-img"/>

                    </div>
                    <div class="col-6 detalhes-QRCode">
                        <h6 class="dados-qrcode-modal">Você está pagando:</h6>
                        <span >{{valorQRCode| currency}}</span>
                        <h6 class="dados-qrcode-modal">Para a empresa:</h6>
                        <span >Bankei Beneflsex Benefícios e Similares S/A</span>
                        <h6 class="dados-qrcode-modal">A ser creditado na conta digital de:</h6>
                        <span > {{assignorInfo.nickName}}</span>
                        <h6 class="dados-qrcode-modal">Ou, copie o código abaixo, abra o app do seu banco ou instituição financeira e utilize a opção PIX Copia e Cola:</h6>
                        <span >{{qrCodePix.brCode}}</span>
                    </div>
                    <!-- <p class="clean-modal-subtitle">
                        {{qrCodePix.brCode}}
                    </p> -->
                    <div class="col-12 mt-2">
                        <button class="btn btn-outline-danger btn-fechar-modal-qrcode" type="button" (click)="modal.dismiss('Close click'); buscarPagamentos();">
                            Fechar
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <!--  -->
</ng-template>

<!--Modal de Aviso-->
<ng-template #modalAvisoInscricaoMunicipal let-modal>
    <div class="col-12 modal-header clean-modal-header">
        <div class="col-md-12">
            <h5 class="modal-title clean-modal-title">
                Dados da Empresa
            </h5>
            <p class="clean-modal-subtitle" style="font-size: 20px;">
                Para gerar uma intenção de depósito, primero informe sua Inscrição Municipal.<br>
                Atualize os dados!
            </p>
        </div>
    </div>
    <div class="col-12 clean-modal-footer">
        <button class="custom-filter-button button-cancel mr-2" type="button" (click)="modal.dismiss('Close click');">Fechar</button>
        <button class="custom-filter-button custom-filter-button-just" style="background-position: 90% 50%" type="button" type="button" (click)="modal.dismiss('Close click');navigateToDadosEmpresa();">Atualizar Dados</button>
    </div>
</ng-template>
